import React, { useRef } from 'react';
import {
  BsFillTelephoneFill,
  BsFillTelephoneInboundFill,
  BsFillTelephoneOutboundFill,
  BsFillTelephoneXFill
} from 'react-icons/bs';
import { FaPhone, FaReceipt } from 'react-icons/fa';
import { HiChat } from 'react-icons/hi';
import { useSelector } from 'react-redux';
import { UncontrolledTooltip } from 'reactstrap';
import styled from 'styled-components';
import { statusColors } from 'views/Monitoring/Queue/MonitoringScreen/utils/state_colors';
import store from 'store';

const ChatAndPhoneContainer = styled.div`
  display: flex;
  column-gap: 0.5rem;
  row-gap: 0.125rem;
  flex-wrap: wrap;

  > span {
    display: flex;
    column-gap: 0.25rem;
    align-items: center;
  }
`;

export function MonitoringUnifiedOnlyChat({ getValue }) {
  const value = getValue();
  const systemConfiguration = useSelector((state) => state.systemConfiguration);

  return (
    <ChatAndPhoneContainer>
      <span>
        <HiChat
          style={{
            fontSize: 'large',
            color: systemConfiguration?.primary_color || 'currentColor'
          }}
        />
        {value ?? '-'}
      </span>
    </ChatAndPhoneContainer>
  );
}

export function MonitoringUnifiedOnlyPhone({ getValue }) {
  const value = getValue();
  const systemConfiguration = useSelector((state) => state.systemConfiguration);

  return (
    <ChatAndPhoneContainer>
      <span>
        <FaPhone
          style={{
            rotate: '90deg',
            width: '18px',
            color: systemConfiguration?.secondary_color || 'currentColor'
          }}
        />
        {value ?? '-'}
      </span>
    </ChatAndPhoneContainer>
  );
}

export function MonitoringUnifiedOnlyProtocol({ getValue }) {
  const value = getValue();
  const systemConfiguration = useSelector((state) => state.systemConfiguration);

  return (
    <ChatAndPhoneContainer>
      <span>
        <FaReceipt
          size={14}
          style={{
            color: systemConfiguration?.secondary_color || 'currentColor'
          }}
        />
        {value ?? '-'}
      </span>
    </ChatAndPhoneContainer>
  );
}

export function MonitoringUnifiedQueuesChatAndPhone({ getValue }) {
  const value = getValue();
  const systemConfiguration = useSelector((state) => state.systemConfiguration);

  return (
    <ChatAndPhoneContainer>
      <span>
        <HiChat
          style={{
            fontSize: 'large',
            color: systemConfiguration?.primary_color || 'currentColor'
          }}
        />
        {value?.chat ?? '-'}
      </span>
      <span>
        <FaPhone
          style={{
            rotate: '90deg',
            width: '18px',
            color: systemConfiguration?.secondary_color || 'currentColor'
          }}
        />
        {value?.telephony ?? '-'}
      </span>
    </ChatAndPhoneContainer>
  );
}

export function MonitoringUnifiedAgentsChatAndPhoneBoolean({ getValue }) {
  const value = getValue();

  return (
    <ChatAndPhoneContainer>
      <span>
        <HiChat
          style={{
            fontSize: 'large',
            color: value?.chat ? statusColors?.PAUSE || 'currentColor' : '#ccc'
          }}
        />
      </span>
      <span>
        <FaPhone
          style={{
            rotate: '90deg',
            width: '18px',
            color: value?.telephony
              ? statusColors?.PAUSE || 'currentColor'
              : '#ccc'
          }}
        />
      </span>
    </ChatAndPhoneContainer>
  );
}

export function MonitoringUnifiedQueuesTooltipChatAndTelephone({ getValue }) {
  const value = getValue();
  const systemConfiguration = useSelector((state) => state.systemConfiguration);
  const chatRef = useRef();
  const telephonyRef = useRef();

  return (
    <ChatAndPhoneContainer>
      <span ref={chatRef}>
        <HiChat
          style={{
            fontSize: 'large',
            color: systemConfiguration?.primary_color || 'currentColor'
          }}
        />
        {value?.chat?.length ?? '-'}
      </span>
      <span ref={telephonyRef}>
        <FaPhone
          style={{
            rotate: '90deg',
            width: '18px',
            color: systemConfiguration?.secondary_color || 'currentColor'
          }}
        />
        {value?.telephony?.length ?? '-'}
      </span>

      {!!value?.chat?.length && (
        <UncontrolledTooltip target={chatRef}>
          {value?.chat?.join?.(', ')}
        </UncontrolledTooltip>
      )}
      {!!value?.telephony?.length && (
        <UncontrolledTooltip target={telephonyRef}>
          {value?.telephony?.join?.(', ')}
        </UncontrolledTooltip>
      )}
    </ChatAndPhoneContainer>
  );
}

export function MonitoringUnifiedQueuesActiveAndReceivedCalls({ getValue }) {
  const value = getValue();
  const systemConfiguration = useSelector((state) => state.systemConfiguration);

  return (
    <ChatAndPhoneContainer>
      <ChatAndPhoneContainer>
        <span title="Chamadas atendidas">
          <BsFillTelephoneFill
            style={{
              color: systemConfiguration?.primary_color || 'currentColor'
            }}
          />
          {value?.answered ?? '-'}
        </span>
        <span title="Chamadas não atendidas">
          <BsFillTelephoneXFill
            style={{
              color: systemConfiguration?.primary_color || 'currentColor'
            }}
          />
          {value?.notAnswered ?? '-'}
        </span>
      </ChatAndPhoneContainer>
      <ChatAndPhoneContainer>
        <span title="Chamadas ativas">
          <BsFillTelephoneOutboundFill
            style={{
              color: systemConfiguration?.secondary_color || 'currentColor'
            }}
          />
          {value?.active ?? '-'}
        </span>
        <span title="Chamadas receptivas">
          <BsFillTelephoneInboundFill
            style={{
              color: systemConfiguration?.secondary_color || 'currentColor'
            }}
          />
          {value?.received ?? '-'}
        </span>
      </ChatAndPhoneContainer>
    </ChatAndPhoneContainer>
  );
}

export const MonitoringUnifiedAgentNameWrapper = styled.div`
  margin-block: auto;
  overflow: hidden;
  whitespace: nowrap;
  /* O cálculo é apenas para evitar de o nome ficar colado no limite da célula, os valores podem ser ajustados */
  max-width: calc(100% - 0.5lh);
  text-overflow: ellipsis;
  font-weight: 500;
`;

export const MonitoringUnifiedExtensionTag = styled.span`
  padding: 0.125rem 0.5rem;
  border-radius: 0.5rem;
  background-color: #999;
  color: white;
  font-weight: bold;
`;
